import React from 'react';
import CanalEducacaoTerm from './Terms/CanalEducacaoTerm';
import DefaultTerm from './Terms/DefaultTerm';
import { useEffect } from 'react';

const Terms = props => {
  const appName = process.env.REACT_APP_NAME;

  const logo = appName === 'aprovavp' ? require(`@/assets/images/${appName}/white-horizontal-logo.svg`) : require(`@/assets/images/${appName}/horizontal-logo.svg`);

  switch (appName) {
    case 'canaleducacao':
    case 'encceja':
    case 'maiseducacao':
    case 'egepi':
      return (
        <div className="terms">
          <CanalEducacaoTerm />
        </div>
      );

    // ================ SEM TERMOS ================
    case 'aprovavp':
    case 'sett-solutions':
      return (
        <div className="terms_background h-screen">
          <div className="terms__screen">
            <div className="terms__brand">
              <img
                alt="Logo Estudologia"
                src={logo}
              />
            </div>
            <div className="terms__container">
              <h1>Termos de uso e Política de privacidade</h1>
              <p className="mb-4">Em breve...</p>
            </div>
          </div>
        </div>
      );

    // ================ TERMOS ESTUDOLOGIA ================
    default:
      return (
        <div className="terms_background">
          <DefaultTerm />
        </div>
      );
  }
};

export default Terms;
